const RolesServices = (function() {
  return {
    isReview: function(state) {
      const user = state.user;
      if (!user) return false;
      if (!user.roles) return false;
      const roles = user.roles.split(",");
      if (!roles) return false;
      if (roles.includes("a") || roles.includes("sa") || roles.includes("r"))
        return true;
      return false;
    },

    isAdmin: function(state) {
      const user = state.user;
      if (!user) return false;
      if (!user.roles) return false;
      const roles = user.roles.split(",");
      if (!roles) return false;
      if (roles.includes("a") || roles.includes("sa")) return true;
      return false;
    },

    isSuperAdmin: function(state) {
      const user = state.user;
      if (!user) return false;
      if (!user.roles) return false;
      const roles = user.roles.split(",");
      if (!roles) return false;
      if (roles.includes("sa")) return true;
      return false;
    }
  };
})();

export default RolesServices;
